
<template>
    <div class="foot" v-if="visible">
        <!-- <p>
            <div style="color: #939393;">
                备案/许可证编号: <a style="color: #939393;" href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank">皖ICP备19005638号-2</a>
            </div>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402702080" style="display: inline-block; text-decoration: none; height: 20px; line-height: 20px;">
                <img src="http://www.scimence.cn:8002/tools/site_pic/beian.png" style="float: left;" />
                <p style="float: left; height: 20px; line-height: 20px; margin: 0px 0px 0px 5px; color: #939393;">皖公网安备34010402702080号</p>
            </a>
        </p> -->

        <a  href="https://beian.miit.gov.cn/" rel="nofollow" target="_blank">皖ICP备19005638号-2</a>
        <a  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=34010402702080" rel="nofollow" target="_blank">皖公网安备34010402702080号</a>

    </div>
</template>

<script>
export default {
  components: {},
  props: {
    // soft: String,
  },
  data () {
    return {
      visible: true,
    }
  },

  mounted() {},
  created() {},
  methods: {}

}
</script>

<style scoped>

    .foot {
        font-size: 12px;
        text-align: center;
        color: #939393;

        position: fixed;
        top: calc(100vh - 32px);
        width: 100%;
    }

    .foot a{
        color: #bbb;
        
        display: inline-block; 
        text-decoration: none; 
        height: 20px; 
        line-height: 20px;

        margin-right: 5px;
    }

    .foot :hover{
        color: black;
    }

</style>


// WEBPACK FOOTER //
// src/components/PannelFoot.vue